import { UserRoleEnum } from '../../enums/role';

export type MonitoringPersona = 'TOWER' | 'CONSULTANT' | 'MANAGER';

type CampaignsAction = 'inspectionsSidebar' | 'campaignsDialog';

interface MonitoringPersonaConfig {
    persona: MonitoringPersona;
    userRole: UserRoleEnum;
    basePath: string;
    showAccounts: boolean;
    canEditMaintenanceGroup: boolean;
    campaignsAction: CampaignsAction;
    exportOnResponsive: boolean;
    canCreateScheduling: boolean;
}

const monitoringPersonaConfig: Record<MonitoringPersona, MonitoringPersonaConfig> = {
    TOWER: {
        persona: 'TOWER',
        userRole: UserRoleEnum.TOWER,
        basePath: '/control-tower',
        showAccounts: true,
        canEditMaintenanceGroup: true,
        campaignsAction: 'inspectionsSidebar',
        exportOnResponsive: false,
        canCreateScheduling: true,
    },
    CONSULTANT: {
        persona: 'CONSULTANT',
        userRole: UserRoleEnum.CONSULTANT,
        basePath: '/dealership',
        showAccounts: true,
        canEditMaintenanceGroup: true,
        campaignsAction: 'inspectionsSidebar',
        exportOnResponsive: true,
        canCreateScheduling: true,
    },
    MANAGER: {
        persona: 'MANAGER',
        userRole: UserRoleEnum.MANAGER,
        basePath: '/fleet-manager',
        showAccounts: false,
        canEditMaintenanceGroup: false,
        campaignsAction: 'campaignsDialog',
        exportOnResponsive: false,
        canCreateScheduling: false,
    },
};

export const getMonitoringPersonaConfig = (persona: MonitoringPersona): MonitoringPersonaConfig =>
    monitoringPersonaConfig[persona];
